const icons = {
  semaforo: (
    <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <rect x="7" y="2" width="10" height="20" rx="3" />
      <circle cx="12" cy="6.5" r="1.6" fill="#EF4444" stroke="none" />
      <circle cx="12" cy="12" r="1.6" fill="#F59E0B" stroke="none" />
      <circle cx="12" cy="17.5" r="1.6" fill="#00E6A5" stroke="none" />
    </svg>
  ),
  car: (
    <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M3 13l1.8-4.6A2 2 0 0 1 6.7 7h7.2a2 2 0 0 1 1.8 1.1L18 12h1.5a2 2 0 0 1 2 2v3h-2.5" />
      <path d="M3 13h18" />
      <circle cx="7.5" cy="17" r="2" />
      <circle cx="16.5" cy="17" r="2" />
      <path d="M9.5 17h5" />
    </svg>
  ),
  plug: (
    <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M9 2v5M15 2v5" />
      <path d="M6 7h12v4a6 6 0 0 1-12 0V7z" />
      <path d="M12 17v5" />
      <path d="M13 9l-2 3h3l-2 3" strokeWidth="1.6" />
    </svg>
  ),
  wind: (
    <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M17.7 7.7a2.5 2.5 0 1 1 1.8 4.3H2" />
      <path d="M9.6 4.6A2 2 0 1 1 11 8H2" />
      <path d="M12.6 19.4A2 2 0 1 0 14 16H2" />
    </svg>
  ),
};

const features = [
  {
    id: "semaforo",
    icon: icons.semaforo,
    title: 'Semáforo "¿Llegás?"',
    text: "Verde, amarillo o rojo instantáneo según tu batería y el consumo real de la ruta.",
    testid: "feature-semaforo",
  },
  {
    id: "modelos",
    icon: icons.car,
    title: "+50 modelos EV en Uruguay",
    text: "BYD, Tesla, MG, JAC, Renault, Nissan y más, con curvas de carga reales.",
    testid: "feature-modelos",
  },
  {
    id: "cargadores",
    icon: icons.plug,
    title: "208 cargadores en vivo",
    text: "Red UTE, Mové, eOne y Evergo actualizada: libre u ocupado, en tiempo real.",
    testid: "feature-cargadores",
  },
  {
    id: "clima",
    icon: icons.wind,
    title: "Clima real en ruta",
    text: "Temperatura y viento incorporados al cálculo de autonomía.",
    testid: "feature-clima",
  },
];

export default function Features() {
  return (
    <section className="section" id="funciones" data-testid="features-section">
      <div className="container">
        <div className="section-head reveal">
          <h2>Todo para manejar eléctrico sin ansiedad</h2>
          <p>Las cuatro herramientas que hacen que viajar en EV por Uruguay sea obvio.</p>
        </div>
        <div className="features-grid" data-testid="features-grid">
          {features.map((f, i) => (
            <article
              key={f.id}
              className="feature-card reveal"
              style={{ transitionDelay: `${i * 90}ms` }}
              data-testid={f.testid}
            >
              <div className="feature-icon">{f.icon}</div>
              <h3>{f.title}</h3>
              <p>{f.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
